export { AppPage } from './app-page';
export { appPageI18n } from './app-page.i18n'